import cx from 'classnames'
import React from 'react'

import GuideSummary from '@cinch/oxd-components/guide-summary/src'
import { GuideSummaryProps } from '@cinch/oxd-components/guide-summary/src/guide-summary.component'
import Link, { Appearance, Size } from '@cinch/oxd-components/link/src'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import * as styles from './homepage-articles.module.css'

export interface Article extends GuideSummaryProps {
  link: string
}

const HomepageArticles: React.FC<{
  i18n: Cinch.WebAppTranslations['home']['articles']
  ctaLink: string
  articles: Article[]
  customStyles?: any
}> = ({ i18n, articles, ctaLink, customStyles = {} }) => (
  <div className={styles.homepageArticles}>
    <Text className={styles.title} type={TextStyles.vehicleSubTitle} element={'h3'}>
      {i18n.title}
    </Text>
    <div className={cx(styles.articles, customStyles.articles)}>
      {articles.map((article) => (
        <Link
          className={cx(styles.articleLink, customStyles.articleLink)}
          to={article.link}
          key={article.id}
          aria-label={article.headline}
        >
          <GuideSummary
            {...article}
            className={cx(styles.article, customStyles.article)}
            customStyles={{
              imageContainer: styles.articleImageContainer,
              customImageContainer: styles.articleCustomImageContainer,
              description: styles.articleDescription,
              title: styles.articleTitle,
              image: styles.articleImage,
              metaContainer: styles.articleMetaContainer,
            }}
          />
        </Link>
      ))}
    </div>
    <Link appearance={Appearance.outlineButton} size={Size.mini} className={styles.button} to={ctaLink}>
      {i18n.cta}
    </Link>
  </div>
)

export default HomepageArticles
